import { DeletePartnerMaterialFileResponseSchema } from './delete-partner-material-file.schema';
export const deletePartnerMaterialFileContract = {
    method: 'DELETE',
    path: '/api/v2/admin/partner-materials/:id/files/:locale',
    description: 'Remove the file of one language',
    responseSchema: DeletePartnerMaterialFileResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - superadmin only',
            404: 'Partner material not found'
        }
    }
};

//# sourceMappingURL=delete-partner-material-file.contract.js.map